import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, tap } from 'rxjs/operators';
import { ProjectQuery } from 'src/app/projects/state/project.query';
import { GeometricFormService } from '../../state/geometric-form.service';
import { GeometricFormType } from '../../state/geometric-form.type';
import { Building } from '../../buildings/state/building.model';
import { BuildingStore } from '../../buildings/state/building.store';
import { BuildingBorder } from './building-border.model';
import { BuildingBorderStore } from './building-border.store';

@Injectable({ providedIn: 'root' })
export class BuildingBorderService extends GeometricFormService<BuildingBorder>{

  constructor(
    private buildingBorderStore: BuildingBorderStore,
    private projectQuery: ProjectQuery,
    private http: HttpClient
  ) {
    super(buildingBorderStore);
  }

  get() {
    this.buildingBorderStore.setLoading(true);
    return this.http.get<BuildingBorder[]>(`/api/project/${this.projectQuery.getActiveId()}/building-border`)
      .pipe(tap(entities => {
        this.buildingBorderStore.set(entities);
      }),
        finalize(() => this.buildingBorderStore.setLoading(false))
      );
  }

  add(building: BuildingBorder) {
    return this.http.post(`/api/project/${this.projectQuery.getActiveId()}/building-border`, building)
      .pipe(tap(b => {
        this.buildingBorderStore.add(b);
      }));
  }

  update(id: number, building: Partial<BuildingBorder>) {
    return this.http.put(`/api/project/${this.projectQuery.getActiveId()}/building-border/${id}`, building)
      .pipe(tap(b => {
        this.buildingBorderStore.update(id, b);
      }));
  }

  remove(id: number) {
    return this.http.delete(`/api/project/${this.projectQuery.getActiveId()}/building-border/${id}`)
      .pipe(tap(() => {
        this.buildingBorderStore.remove(id);
      }));
  }

  getType(): GeometricFormType {
    return 'mitra-building-border';
  }


  filter(legends: string[]) {

    if (!legends.length) {
      this.buildingBorderStore.update(null, { hidder: false });
      return;
    }

    this.buildingBorderStore.update(null, ({ map_legend }) => {
      return {
        hidder: legends.indexOf(map_legend) < 0
      };
    });
  }

}
